import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { FormControl, MenuItem, Select } from '@mui/material';

import { SUPPORTED_LANGUAGES, languageOptionLabel } from '../i18n';

export default function LanguageSwitcher() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const current = i18n.resolvedLanguage;

  const onChange = (event) => {
    const code = event.target.value;
    if (!code || code === current) return;

    // The path is the source of truth for the active language; the route effect
    // in App.js calls changeLanguage once the URL updates.
    navigate(`/${code}`);
  };

  return (
    <FormControl size="small">
      <Select
        value={current}
        onChange={onChange}
        inputProps={{ 'aria-label': t('language.label') }}
      >
        {SUPPORTED_LANGUAGES.map((language) => (
          <MenuItem key={language.code} value={language.code} lang={language.code}>
            {languageOptionLabel(language)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
